import { createContext, use } from "react";

import type { JsHeapSnapshot } from "context/CogOrtho/jsHeapMemory";

export const formatBytesCompact = (bytes: number): string => {
  if (bytes >= 1024 * 1024 * 1024) {
    return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} GiB`;
  }
  if (bytes >= 1024 * 1024) {
    return `${(bytes / (1024 * 1024)).toFixed(1)} MiB`;
  }
  if (bytes >= 1024) {
    return `${(bytes / 1024).toFixed(1)} KiB`;
  }
  return `${bytes} B`;
};

export type OrthoLodMode = "overview" | "detail-full";

export interface OrthoLodDebugInfo {
  detailCacheBlobBytes: number;
  detailCachePeakBlobBytes: number;
  detailCacheSize: number;
  geotiffBlockCacheBudgetBytes: number;
  jsHeap: JsHeapSnapshot | null;
  mapZoom: number;
  mode: OrthoLodMode;
  overviewBlobBytes: number;
  visibleTileCount: number;
}

export interface OrthoLodDebugContextValue {
  orthoLodDebug: OrthoLodDebugInfo;
  setOrthoLodDebug: (info: OrthoLodDebugInfo) => void;
}

export const DEFAULT_ORTHO_LOD_DEBUG: OrthoLodDebugInfo = {
  detailCacheBlobBytes: 0,
  detailCachePeakBlobBytes: 0,
  detailCacheSize: 0,
  geotiffBlockCacheBudgetBytes: 0,
  jsHeap: null,
  mapZoom: 0,
  mode: "overview",
  overviewBlobBytes: 0,
  visibleTileCount: 0,
};

export const OrthoLodDebugContext =
  createContext<OrthoLodDebugContextValue | null>(null);

export const useOrthoLodDebug = (): OrthoLodDebugContextValue => {
  const context = use(OrthoLodDebugContext);
  if (context == null) {
    throw new Error(
      "useOrthoLodDebug must be used within OrthoLodDebugProvider",
    );
  }
  return context;
};
